export * from "./lib/emptyStates";
export * from "./lib/flags";
export * from "./lib/logos";
export * from "./lib/products";
export * from "./lib/systems";

/**
 * Following icons are deprecated and should be removed in the next major release.
 * For each icon the emerald replacement icon is given.
 */
export const deprecated = {
  sy_notification_error: 'Renamed to sy_notification_error_16',
  sy_notification_error_outlined: 'Renamed to sy_notification_error_outlined_16',
  sy_notification_inactive: 'Replaced by sy_notification_info_16 n400',
  sy_notification_inactive_outlined: 'Replaced by sy_notification_info_outlined_16 n400',
  sy_notification_info: 'Replaced by sy_notification_info_16',
  sy_notification_info_outlined: 'Replaced by sy_notification_info_outlined_16',
  sy_notification_negative: 'Replaced by sy_notification_error_16',
  sy_notification_positive: 'Replaced by sy_notification_verified_16',
  sy_notification_privacy: 'Renamed to sy_notification_privacy_24 or sy_notification_privacy_16',
  sy_notification_verified: 'Renamed to sy_notification_verified_24 or sy_notification_verified_16',
  sy_notification_verified_outlined: 'Renamed to sy_notification_verified_outlined_16',
  sy_notification_warning: 'Renamed to sy_notification_warning_16',
  sy_notification_warning_outlined: 'Renamed to sy_notification_warning_outlined_16',
  pr_empty_state_msb_tile: 'Moved to Empty States icons: emptyStates.em_msb_tile',
};
